var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-content main_center",
      style: _vm.mainContentViewHeight,
    },
    [
      _c("div", { staticClass: "search-content" }, [
        _c(
          "div",
          { staticClass: "mainBtn" },
          [
            _vm.hasBtnPermission("btn_jz_custom_menus_add")
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.addOrUpdateHandle("")
                      },
                    },
                  },
                  [_vm._v("新增")]
                )
              : _vm._e(),
            _vm.hasBtnPermission("btn_jz_custom_menus_delete")
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteHandle()
                      },
                    },
                  },
                  [_vm._v("删除 ")]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-download",
                  size: "small",
                  type: "primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.exportTableData()
                  },
                },
              },
              [_vm._v("导出 ")]
            ),
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                staticStyle: {
                  display: "inline-block",
                  width: "100px",
                  "margin-left": "10px",
                },
                attrs: {
                  action: _vm.actionUrl,
                  "before-upload": _vm.beforeFileUpload,
                  data: _vm.actionQuery,
                  "list-type": "xlsx",
                  "on-change": _vm.fileChange,
                  "on-error": _vm.handleUploadError,
                  "on-success": _vm.handleUploadSuccess,
                  "show-file-list": false,
                  accept: ".xlsx",
                },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-upload",
                      size: "small",
                      type: "primary",
                    },
                  },
                  [_vm._v("导入 ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "searchBtn" },
          [
            _c("span", { staticClass: "label-form" }, [_vm._v("关键字：")]),
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请输入内容搜索" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchBtn.apply(null, arguments)
                },
              },
              model: {
                value: _vm.dataForm.searchKey,
                callback: function ($$v) {
                  _vm.$set(_vm.dataForm, "searchKey", $$v)
                },
                expression: "dataForm.searchKey",
              },
            }),
            _c("span", { staticClass: "label-form" }, [_vm._v("业务类型：")]),
            _c(
              "el-select",
              {
                staticStyle: { width: "150px", display: "inline-block" },
                attrs: { clearable: "", "value-key": "value" },
                on: { change: _vm.searchBtn },
                model: {
                  value: _vm.dataForm.busType,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "busType", $$v)
                  },
                  expression: "dataForm.busType",
                },
              },
              _vm._l(_vm.businessTypeNamelist, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.name, value: item.value },
                })
              }),
              1
            ),
            _c("span", { staticClass: "label-form" }, [_vm._v("表单类型：")]),
            _c(
              "el-select",
              {
                staticStyle: { width: "150px", display: "inline-block" },
                attrs: { clearable: "", "value-key": "value" },
                on: { change: _vm.searchBtn },
                model: {
                  value: _vm.dataForm.formType,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "formType", _vm._n($$v))
                  },
                  expression: "dataForm.formType",
                },
              },
              _vm._l(_vm.formTypeList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.text, value: item.id },
                })
              }),
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "12px" },
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.searchBtn },
              },
              [_vm._v("搜索")]
            ),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _c("el-button", {
              attrs: { icon: "el-icon-refresh", type: "text" },
              on: { click: _vm.refresh },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          ref: "customFormList",
          staticClass: "table-content",
          attrs: {
            data: _vm.dataList,
            border: "",
            stripe: "",
            "header-cell-style": this.$globalGrayTableHeaderStyle,
            height: _vm.tableMaxHeight,
          },
          on: { "selection-change": _vm.selectionChangeHandle },
        },
        [
          _vm.hasBtnPermission("btn_jz_custom_menus_delete")
            ? _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "selection",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              type: "index",
              align: "center",
              label: "序号",
              width: "60",
              index: _vm.getRowsIndex,
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              "header-align": "center",
              align: "center",
              width: "150",
              label: "操作",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.hasBtnPermission("btn_jz_custom_menus_add")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.configDataset(
                                  scope.row.id,
                                  scope.row.displayName,
                                  scope.row.formType
                                )
                              },
                            },
                          },
                          [_vm._v(" 配置 ")]
                        )
                      : _vm._e(),
                    _vm.hasBtnPermission("btn_jz_custom_menus_add")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.addOrUpdateHandle(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(" 修改 ")]
                        )
                      : _vm._e(),
                    _vm.hasBtnPermission("btn_jz_custom_menus_delete")
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteHandle(scope.row.id)
                              },
                            },
                          },
                          [_vm._v(" 删除 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "code",
              "header-align": "left",
              width: "150",
              align: "left",
              label: "表单编号",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              "header-align": "left",
              align: "left",
              label: "表单名称",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "formType",
              "header-align": "center",
              align: "center",
              width: "80",
              label: "表单类型",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.formType == 0
                      ? _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v("列表"),
                        ])
                      : scope.row.formType == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "small" } },
                          [_vm._v("编辑")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "small", type: "danger" } },
                          [_vm._v("明细")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "hasAttach",
              "header-align": "center",
              align: "center",
              width: "110",
              label: "是否支持附件",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.hasAttach == true
                      ? _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v("是"),
                        ])
                      : _c(
                          "el-tag",
                          { attrs: { size: "small", type: "danger" } },
                          [_vm._v("否")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "hasFlow",
              "header-align": "center",
              align: "center",
              width: "110",
              label: "是否支持流程",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.hasFlow == true
                      ? _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v("是"),
                        ])
                      : _c(
                          "el-tag",
                          { attrs: { size: "small", type: "danger" } },
                          [_vm._v("否")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              "header-align": "center",
              align: "center",
              width: "180",
              label: "创建时间",
            },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pageIndex,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          total: _vm.totalPage,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
      _vm.addOrUpdateVisible
        ? _c("add-or-update", {
            ref: "addOrUpdate",
            on: { refreshDataList: _vm.getDataList },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }